import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Transfer({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M3.55251 5.04663C3.4908 5.40961 3.73503 5.75389 4.09801 5.8156L7.8159 6.44766L8.03937 5.13318L5.87126 4.7646C7.56428 3.44937 9.6901 2.66667 12.0005 2.66667C14.3627 2.66667 16.5319 3.48488 18.2429 4.85389L19.0759 3.81279C17.137 2.26145 14.6762 1.33334 12.0005 1.33334C9.42433 1.33334 7.04744 2.19363 5.14375 3.6421L5.49904 1.5522L4.18457 1.32874L3.55251 5.04663ZM5.59132 4.68463L5.61848 4.72162L5.62147 4.72213L5.59132 4.68463Z"
        fill={iconColor}
      />
      <Path
        d="M12.0001 14C13.1046 14 14.0001 13.1046 14.0001 12C14.0001 10.8954 13.1046 10 12.0001 10C10.8955 10 10.0001 10.8954 10.0001 12C10.0001 13.1046 10.8955 14 12.0001 14Z"
        fill={iconColor}
      />
      <Path
        d="M4.66672 7.33334C4.29853 7.33334 4.00005 7.63181 4.00005 8V16C4.00005 16.3682 4.29853 16.6667 4.66672 16.6667H19.3334C19.7016 16.6667 20.0001 16.3682 20.0001 16V8C20.0001 7.63181 19.7016 7.33334 19.3334 7.33334H4.66672ZM5.33339 15.3333V8.66667H18.6667V15.3333H5.33339Z"
        fill={iconColor}
      />
      <Path
        d="M18.1288 19.2354L15.9607 18.8668L16.1842 17.5523L19.9021 18.1844C20.2651 18.2461 20.5093 18.5904 20.4476 18.9534L19.8155 22.6713L18.5011 22.4478L18.8564 20.3579C16.9527 21.8064 14.5758 22.6667 11.9996 22.6667C9.32388 22.6667 6.86306 21.7386 4.92418 20.1872L5.75718 19.1461C7.46818 20.5151 9.63745 21.3333 11.9996 21.3333C14.31 21.3333 16.4358 20.5506 18.1288 19.2354ZM18.4088 19.3154L18.3786 19.2779L18.3816 19.2784L18.4088 19.3154Z"
        fill={iconColor}
      />
    </Svg>
  );
}
